window.getBackButtonHref = function (id) {
    let backButton = document.getElementById(id) || document.querySelector('.back-button');

    if (!backButton) {
        return;
    }

    id = backButton.id;

    if (localStorage.getItem("backButtonHref") && localStorage.getItem('from-back') != 1) {
        backButton.href = localStorage.getItem("backButtonHref");
        localStorage.setItem(id, localStorage.getItem("backButtonHref"));
    } else if (localStorage.getItem(id)) {
        backButton.href = localStorage.getItem(id);
    }
};

window.saveBackButtonHrefValue = function () {
    if (localStorage.getItem('from-back') != 1) {
        localStorage.setItem('backButtonHref', window.location.href);
    } else if (localStorage.getItem('backButtonHref')) {
        if (localStorage.getItem('submitted') != 1) {
            if(!window.location.href.includes('/handin')){
                localStorage.removeItem('backButtonHref');
            }
        } else {
            localStorage.removeItem('submitted');
        }
    }
    localStorage.setItem('from-back', 0);
}

window.addEventListener("beforeunload", saveBackButtonHrefValue);

window.addEventListener('load', function() {
    if (typeof getBackButtonHref === 'function') {
        getBackButtonHref('backButton');
    }
}, true);


if (typeof goBack !== "function") {
    window.goBack = function(backButton, submitted = false) {

        localStorage.removeItem(backButton.id);
        localStorage.setItem('from-back', 1);
    
        let previousPage = localStorage.getItem("backButtonHref") || "";

        if (submitted) {
            localStorage.setItem('submitted', 1);
            return;
        }

        if (previousPage) {
            // prevent go back to 404 page after test or feedback is completed
            if (previousPage.includes("/finish") || previousPage.includes("/start") || previousPage.includes('/login')) {
                location.href = '/';
                return;
            }

            // prevent go back to the meeting participants page (learner area)
            if (previousPage.includes("/meeting")) {
                location.href = '/';
                return;
            }

            if (previousPage.includes("/admin/users")) {
                backButton.href = '/admin/users';
                return;
            }

            if (window.location.href === previousPage) {
                location.href = '/';
                return;
            }

        }

        if (!backButton.href || backButton.href === "" || backButton.href === "#" || backButton.href === window.location.href) {
            window.history.back();
        } else {
            location.href = backButton.href;
        }
    }
    
}


// WEBPACK FOOTER //
// ./resources/assets/js/backButtonHrefSetter.js